import axios from 'axios';

import { Interval } from 'core/util/Aggregate';

export const Group = {
    Day: 1,
    Week: 2,
    Month: 3,
    Quarter: 4,
    Year: 5,
    DayOfWeek: 6,
    TimeOfDay: 7,
    FiscalWeek: 8,
    FiscalMonth: 9,
    FiscalQuarter: 10,
    FiscalYear: 11,
};

export const getDateRangeSets = async (tenantId: number | undefined, args: any): Promise<any> => {
    const params = { args };
    const { data } = await axios.get(`/api/tenants/${tenantId}/date-ranges/date-range-sets`, { params });

    return data;
};

export const getIntervalForGroup = (group: number): number => {
    switch (group) {
        case Group.Day:
        case Group.Week:
        case Group.DayOfWeek:
        case Group.TimeOfDay: {
            return Interval.Day;
        }
        case Group.Month:
        case Group.Quarter:
        case Group.Year: {
            return Interval.Month;
        }
        case Group.FiscalWeek: {
            return Interval.FiscalWeek;
        }
        case Group.FiscalMonth:
        case Group.FiscalQuarter:
        case Group.FiscalYear: {
            return Interval.FiscalMonth;
        }
        default: {
            return Interval.None;
        }
    }
};
